import { gql } from "@apollo/client";
import { CORE_MISSION_ROLE_FIELDS, EXTENDED_MISSION_FIELDS, RATE_RANGE_FIELDS } from "graphql/fragments";

const GET_MISSION_ROLES = gql`
  ${EXTENDED_MISSION_FIELDS}
  ${CORE_MISSION_ROLE_FIELDS}
  ${RATE_RANGE_FIELDS}
  query GetMissionRoles(
    $id: ID = null
    $filters: MissionRoleFilter
    $orderBy: MissionRoleOrderBy
    $paginationInfo: PaginationInfo
    $disablePagination: Boolean
    $first: Int
    $last: Int
    $after: String
    $before: String
    $includeProfilesCount: Boolean = false
    $includeCustomerBudget: Boolean = false
  ) {
    missionRoles(
      id: $id
      paginationInfo: $paginationInfo
      disablePagination: $disablePagination
      filters: $filters
      orderBy: $orderBy
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      totalCount
      currentPage
      perPage
      currentOffset
      nodes {
        ...MissionRoleFields
        totalApplicantsCount
        matchingProfilesCount @include(if: $includeProfilesCount)
        customerBudget @include(if: $includeCustomerBudget) {
          ...RateRangeFields
        }
        mission {
          ...ExtendedMissionFields
        }
        applicantsProfileIds
        missionRoleApplicant {
          id
          uuid
          message
          profile {
            id
            description
            archetype
          }
          state
          appliedAt
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

export { GET_MISSION_ROLES };
